import './App.css';
import React from 'react';
import { Container, createTheme, ThemeProvider } from '@mui/material';

import { ReviewForm } from './components/ReviewForm';
import { WelcomeMessage } from './components/WelcomeMessage';
import { TopMenu } from './components/TopMenu';

function App() {
  const theme = createTheme({
    // set font to PT Serif
    typography: {
      fontFamily: ['PT Serif, serif'].join(','),
    },
    palette: {
      primary: {
        main: '#f6cf00',
        secondary: '#fff',
      },
    },
    components: {
      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundColor: '#212121',
            color: 'white',
            alignItems: 'center',
          },
        },
      },
      MuiTypography: {
        styleOverrides: {
          handwriting: {
            fontFamily: 'Mr Dafoe',
          },
        },
      },
      MuiAlert: {
        styleOverrides: {
          root: {
            backgroundColor: 'rgba(246,207,0,0.21)',
            color: '#212121',
          },
          icon: {
            color: '#212121 !important',
          },
        },
      },

      MuiSlider: {
        styleOverrides: {
          root: {
            width: '100%',
          },
        },
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <TopMenu />
      <Container maxWidth="sm" sx={{ pt: 2 }}>
        <WelcomeMessage />
        <ReviewForm />
      </Container>
    </ThemeProvider>
  );
}

export default App;
